module.exports = __webpack_public_path__ + "img/ic_super_recognition.49d8b80b.png";